// 工程师信息列表
import { getEngineerList } from '@@/api/customer'

// 缓存请求，防止同一时间多次重复请求
let requestCache = null

const state = {
  list: [],
}

const getters = {
  list(state) {
    return state.list
  }
}

const mutations = {
  SET_LIST(state, list) {
    state.list = list
  }
}

const actions = {
  // 获取工程师信息列表
  async getEngineerList({ dispatch, state }, needUpdate) {
    try {
      if (needUpdate || !state.list || state.list.length === 0) {
        if (!requestCache) {
          requestCache = dispatch('setEngineerList')
        }
        await requestCache
      }
      return state.list
    } finally {
      requestCache = null
    }
  },
  // 设置
  async setEngineerList({ commit }) {
    const res = await getEngineerList()
    if (res && res.suc) {
      commit('SET_LIST', res.body || [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}